import { Injectable } from '@angular/core';
import proj4 from 'proj4'
import { TranslateService } from '@ngx-translate/core';
import { GPSUnit } from '../account/account.model';

@Injectable({
  providedIn: 'root'
})
export class UTMConversionService {

  constructor(private translate: TranslateService) {}

  private utmZoneFromLong(lonDeg: number): number {
    // Get UTM zone from longitude degrees
    return Math.floor(((lonDeg + 180) / 6) % 60) + 1;
  }

  private proj4SetDef(lonDeg: number): string {
    // Get UTM projection definition from longitude
    const utmZone = this.utmZoneFromLong(lonDeg);
    return `+proj=utm +zone=${utmZone} +datum=WGS84 +units=m +no_defs`;
  }

  private convertCoordinates(lat: number, lon: number): string {
    const azone = this.utmZoneFromLong(lon);

    // Define proj4_defs for easy use
    proj4.defs([
      [
        'EPSG:4326',
        '+title=WGS 84 (long/lat) +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees'
      ],
      ['EPSG:AUTO', this.proj4SetDef(lon)]
    ]);

    // Conversion from (long/lat) to UTM (E/N)
    const enM = proj4('EPSG:4326', 'EPSG:AUTO', [lon, lat]);
    const e4digits = enM[0].toFixed(4); // easting
    const n4digits = enM[1].toFixed(4); // northing

    return "UTM " + azone + " " + e4digits + " " + n4digits;

    return this.translate.instant('coordinates.utm', {
      letter: this.formatNumber(azone),
      easting: this.formatNumber(parseFloat(e4digits)),
      northing: this.formatNumber(parseFloat(n4digits))
    });
  }

  private formatNumber(value: number): string {
    // Format number for display (e.g., using Angular's decimal pipe)
    return new Intl.NumberFormat().format(value);
  }

  useOrConvertCoordinates(lat: number, lon: number, settings: GPSUnit = GPSUnit.UTM): string {
    console.log("useOrConvertCoordinates", settings);
    if (settings === GPSUnit.LAT_LON) {
      return "Latitude: " + lat.toFixed(4) + " Longitude: " + lon.toFixed(4);
      // return this.translate.instant('coordinates.latLng', {
      //   latitude: this.formatNumber(Number(lat.toFixed(4))),
      //   longitude: this.formatNumber(Number(lon.toFixed(4)))
      // });
    } else {
      return this.convertCoordinates(lat, lon);
    }
  }
}
